import { GapManagementDashboardService } from "@app/projects/network-assessment/gap-management-dashboard/gapManagementDashboardService";
import { GmdWidgetProps } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gmdWidgetProps";
import { MetricsListLite } from "@app/shared/metrics/MetricsListLite";
import { QESWidget, QESWidgetHeader, QESWidgetTitle, QESWidgetContent } from "@app/shared/widget";
import { useQuery } from "@tanstack/react-query";
import { FC, useRef } from "react";

export const ResolutionStatusWidget: FC<GmdWidgetProps> = ({ errorBanner, loadingIcon }) => {
  const gapManagementDashboardService = useRef(new GapManagementDashboardService()).current;

  const { data: resolutionStatusData, isError, isLoading } = useQuery({
    enabled: true,
    queryFn: ({ signal }) => gapManagementDashboardService.getResolutionStatusData(signal),
    queryKey: ["gmd-resolution-status"],
  });

  return (
    <QESWidget className="gap-management-dashboard__widget">
      <QESWidgetHeader>
        <QESWidgetTitle>Resolution Status</QESWidgetTitle>
      </QESWidgetHeader>
      <QESWidgetContent>
        {isLoading ? loadingIcon :
          isError ? errorBanner : (
            <MetricsListLite
              {...resolutionStatusData}
            />
          )}
      </QESWidgetContent>
    </QESWidget>
  )
}